import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import PrivacyModal from "./PrivacyModal";
import './Footer.css';
function Footer() {
    const [modalShow, setModalShow] = React.useState(false);
    return (
        <footer className="footer-wrapper">
            <Container>
                <Row className="align-items-center">
                    <Col xl={4}>
                        Copyright &copy; {new Date().getFullYear()}, Gulf Oil India | <span className="text-nowrap"><a href="#" onClick={(e) => {setModalShow(true); e.preventDefault()} } title="T&C">*T&amp;C</a></span>
                    </Col>
                    <Col xl={4} className="follow">
                        <span className="d-inline-block mr-2 mx-md-2">Follow us on</span>
                        <ul className="nav mr-2 mx-md-2">
                            <li><a href="https://www.youtube.com/channel/UCaVcTj9bOw3g-Hw4iV63upQ" target="_blank" rel="noopener noreferrer" title="Youtube" className="ico-soc ico-soc-youtube">Youtube</a></li>
                            <li><a href="https://twitter.com/gulfoilindia" target="_blank" rel="noopener noreferrer" title="Twitter" className="ico-soc ico-soc-twitter">Twitter</a></li>
                            <li><a href="https://www.facebook.com/GulfOilIndia/" target="_blank" rel="noopener noreferrer" title="Facebook" className="ico-soc ico-soc-facebook">Facebook</a></li>
                            <li><a href="https://www.instagram.com/gulfoil.india/" target="_blank" rel="noopener noreferrer" title="Instagram" className="ico-soc ico-soc-instagram">Instagram</a></li>
                        </ul>
                    </Col>
                    <Col xl={4} className="copyright">
                        Designed &amp; Maintained by <a href="http://www.hgsinteractive.com" target="_blank" rel="noopener noreferrer" title="HGS Interactive">HGS Interactive</a>
                    </Col>
                </Row>
            </Container>
            <PrivacyModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </footer>
    );
}

export default Footer;